<nz-form-item>
  <nz-form-label>{{ label }}</nz-form-label>
  <textarea
    [(ngModel)]="data.content"
    [placeholder]="placeholder"
    nz-input
    rows="5"
  ></textarea>
</nz-form-item>
